import { render, staticRenderFns } from "./ChangeTypeDialog.vue?vue&type=template&id=478b287f&scoped=true"
import script from "./ChangeTypeDialog.vue?vue&type=script&lang=js"
export * from "./ChangeTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangeTypeDialog.vue?vue&type=style&index=0&id=478b287f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478b287f",
  null
  
)

export default component.exports